/**
 * The money-back window. One number, because it is stated on the paywall seal,
 * in two FAQ answers, under the purchase button and in the public terms at
 * readparables.com/terms — and those have to agree.
 *
 * The published terms keep the window that applied at the time of purchase, so
 * shortening this does not shorten an existing subscriber's right to a refund.
 */
export const GUARANTEE_DAYS = 14;

export const GUARANTEE_NOTE = `${GUARANTEE_DAYS}-day money-back guarantee`;
